export const visitTypeQuery = `
    id
    name
    description
    active
`;
